import { isAccountUserRole, type AccountUserRole } from "@/domain/model/AccountSeatOverview";
import { isAcceptInviteNextAction, type AcceptInviteNextAction } from "@/domain/model/Invitation";

export function toDate(value: string | null): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function toRequiredDate(value: string | null, fieldName = "date"): Date {
  if (!value) {
    throw new Error(`Missing required ${fieldName}.`);
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    throw new Error(`Invalid required ${fieldName}: ${value}`);
  }

  return date;
}

export function mapNullableAccountUserRole(
  value: string | null | undefined,
): AccountUserRole | null {
  if (value == null) {
    return null;
  }

  return mapAccountUserRole(value);
}

export function mapAccountUserRole(value: string): AccountUserRole {
  if (!isAccountUserRole(value)) {
    throw new Error(`Unsupported account role: ${value}`);
  }

  return value;
}

export function mapAcceptInviteNextAction(value: string): AcceptInviteNextAction {
  if (!isAcceptInviteNextAction(value)) {
    throw new Error(`Unsupported next action: ${value}`);
  }

 return value;
}
